import React from 'react';
import '../RecurringBuy/StartDateToolTip.scss';

const IRAAutoMaxStartDateToolTip = () => (
  <div>
    <div className="start-date-tool-tip-title">
      Important Information Regarding the Scheduled Dates of your Contributions
    </div>
    <div className="start-date-tool-tip-content">
      By selecting this service, you acknowledge that automatic transactions
      will be placed in accordance with the following:
    </div>
    <div className="start-date-tool-tip-content">
      Automatic Transactions programs are typically established the following
      business day, but can take up to three business days to be completed. For
      this reason, a start date that falls within three business days of today’s
      will be unavailable for set-up.
    </div>
    <div className="start-date-tool-tip-content">
      Except for certain dates as noted below, if one of your chosen dates
      occurs on a holiday or weekend, the trade will be placed on the next
      business day at that business day’s Net Asset Value (NAV).
    </div>
    <div className="start-date-tool-tip-content">
      Exception: If your chosen date falls on a day that does not exist on the
      calendar (ex. February 31st) your trade will be placed on the previous
      business day at that business day’s NAV. If your chosen date falls on the
      last weekend of the year, then the contributions for that date will be
      allocated to your previously scheduled dates.
    </div>
  </div>
);

export default IRAAutoMaxStartDateToolTip;
